<template>
  <div class="search-form">
    <el-form
      ref="form"
      size="mini"
      :model="form"
      label-position="left"
      onsubmit="return false"
    >
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_search_fileType') || '文件类型'"
            label-width="70px"
          >
            <dict-select
              v-model="form.listFileType"
              :body="fileTypeParams"
              url="/sys/common/dict/system"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              multiple
              clearable
              filterable
              style="width:100%"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_search_fileName') || '文件名称'"
            label-width="80px"
          >
            <el-input
              v-model="form.fileName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              @keyup.enter.native="query"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query"
          >
            <i class="el-icon-search" />
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            :disabled="disabled"
            @click="$emit('uploadFile')"
          >
            <i class="el-icon-upload" />

            {{ $l('INDEX.btn_upload') || '上传' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
const initForm = { listFileType: [], fileName: '' }
export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      form: { ...initForm },
      fileTypeParams: { dictType: 'customerFileType' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>
